// @ts-nocheck
import { useEffect, useState } from 'react';
import { animated, useTransition } from 'react-spring';
import { User, users } from '../../data/users';
import { TinderCard } from './TinderCard';

// Инициализация Telegram Web App
const tg = window.Telegram.WebApp;

// const TelegramAvatar = ({ userId, botToken }) => {
//   const [avatarUrl, setAvatarUrl] = useState('');
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchAvatar = async () => {
//       try {
//         // Запрос на получение фото профиля
//         const photoResponse = await axios.get(
//           `https://api.telegram.org/bot${botToken}/getUserProfilePhotos?user_id=${userId}`,
//         );

//         const photos = photoResponse.data.result.photos;
//         if (photos.length === 0) {
//           setError('No avatar found');
//           return;
//         }

//         // Получаем file_id первой фотографии
//         const fileId = photos[0][photos[0].length - 1].file_id;

//         // console.log(photoResponse);

//         // const fileId =
//         //   'AgACAgIAAxkBAAIEZ2Nh-TiT3Hem2nt9JqIKZwN20sFyAAJHwTEbkDMRS57uH3fuFlXkAQADAgADcwADKgQ';

//         // Запрос на получение пути к файлу
//         const fileResponse = await axios.get(
//           `https://api.telegram.org/bot${botToken}/getFile?file_id=${fileId}`,
//         );

//         console.log(fileResponse);

//         const filePath = fileResponse.data.result.file_path;
//         const fileUrl = `https://api.telegram.org/file/bot${botToken}/${filePath}`;

//         setAvatarUrl(fileUrl);
//       } catch (err) {
//         setError('Error fetching avatar');
//         console.error(err);
//       }
//     };

//     if (userId && botToken) {
//       fetchAvatar();
//     }
//   }, [userId, botToken]);

//   if (error) {
//     return <div>{error}</div>;
//   }

//   return (
//     <div>
//       {avatarUrl ? (
//         <img
//           src={avatarUrl}
//           alt='Telegram Avatar'
//           style={{ width: '100px', height: '100px', borderRadius: '50%' }}
//         />
//       ) : (
//         <div>Loading...</div>
//       )}
//     </div>
//   );
// };

export const TinderPage = () => {
  // Разворачивание приложения на полный экран при монтировании
  useEffect(() => {
    tg.expand();
    tg.ready();
    // Обработка изменения темы Telegram
    tg.onEvent('themeChanged', () => {
      document.body.classList.toggle('dark', tg.colorScheme === 'dark');
    });
  }, []);

  // Состояния для управления карточками
  const [currentUsers, setCurrentUsers] = useState<User[]>(users);

  // Состояние для хранения информации о пользователе
  const [user, setUser] = useState(tg.initDataUnsafe?.user || null);

  // Анимация для появления новых карточек
  const transitions = useTransition(currentUsers, {
    from: { opacity: 0, transform: 'scale(0.8)' },
    enter: { opacity: 1, transform: 'scale(1) translateX(0px)' },
    config: { tension: 300, friction: 30 },
  });

  // Обработчик свайпа
  const handleSwipe = async (direction: 'left' | 'right') => {
    if (currentUsers.length === 0) return;

    // Удаляем текущую карточку из массива
    setCurrentUsers((prev) => prev.slice(0, -1));
  };

  // Сброс карточек
  const resetCards = () => {
    setCurrentUsers(users);
  };

  // Отображение стека карточек
  const renderCards = () => {
    return transitions((style, user, _, index) => {
      const isTop = index === currentUsers.length - 1;
      const zIndex = index;

      return (
        <animated.div
          key={user.id}
          style={{
            ...style,
            position: 'absolute',
            width: '95%',
            height: '95%',
            zIndex,
            pointerEvents: isTop ? 'auto' : 'none',
          }}
        >
          <TinderCard
            user={user}
            onSwipe={handleSwipe}
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </animated.div>
      );
    });
  };

  return (
    <div className='flex min-h-screen items-center justify-center'>
      {/* <TelegramAvatar
        userId='106489584'
        botToken='5758878648:AAHi3l4ZbNGdM6luC0uKTVJ0E01DGEZJzy0'
      /> */}

      <div className='h-screen w-full'>
        <p className='text-lg'>
          Добро пожаловать, {user?.first_name} {user?.last_name || ''}!
        </p>

        {/* Контейнер для карточек */}
        <div className='relative flex h-full w-full items-center justify-center'>
          {currentUsers.length > 0 ? (
            renderCards()
          ) : (
            <div className='text-center'>
              <div className='mx-auto mb-6 flex h-32 w-32 items-center justify-center rounded-full bg-gray-200 text-4xl'>
                😔
              </div>
              <button
                onClick={resetCards}
                className='rounded-full bg-gradient-to-r from-pink-500 to-purple-600 px-8 py-3 font-semibold text-white shadow-lg transition-all duration-200 hover:from-pink-600 hover:to-purple-700'
              >
                Начать заново
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
